const GoogleAnalyticsEvents = {
    BookingSubmitted: {
        key: 'booking-submitted',
        get description() {
            return this.key + ' - ' + trans('modules.GoogleAnalytics.docs_events_1')
        },
        send(data = {}) {
            GoogleAnalyticsEvents.sendEvent(this.key, data)
        },
    },

    BookingPaid: {
        key: 'booking-paid',
        get description() {
            return this.key + ' - ' + trans('modules.GoogleAnalytics.docs_events_2')
        },
        send(data = {}) {
            GoogleAnalyticsEvents.sendEvent(this.key, data)
        },
    },

    EventSignup: {
        key: 'event-signup',
        get description() {
            return this.key + ' - ' + trans('modules.GoogleAnalytics.docs_events_3')
        },
        send(data = {}) {
            GoogleAnalyticsEvents.sendEvent(this.key, data)
        },
    },

    EventPaid: {
        key: 'event-paid',
        get description() {
            return this.key + ' - ' + trans('modules.GoogleAnalytics.docs_events_4')
        },
        send(data = {}) {
            GoogleAnalyticsEvents.sendEvent(this.key, data)
        },
    },

    ClientLogin: {
        key: 'client-login',
        get description() {
            return this.key + ' - ' + trans('modules.GoogleAnalytics.docs_events_5')
        },
        send(data = {}) {
            GoogleAnalyticsEvents.sendEvent(this.key, data)
        },
    },

    ClientRegistered: {
        key: 'client-registered',
        get description() {
            return this.key + ' - ' + trans('modules.GoogleAnalytics.docs_events_9')
        },
        send(data = {}) {
            GoogleAnalyticsEvents.sendEvent(this.key, data)
        },
    },

    VoucherPurchased: {
        key: 'voucher-purchased',
        get description() {
            return this.key + ' - ' + trans('modules.GoogleAnalytics.docs_events_6')
        },
        send(data = {}) {
            GoogleAnalyticsEvents.sendEvent(this.key, data)
        },
    },

    GiftcardPurchased: {
        key: 'giftcard-purchased',
        get description() {
            return this.key + ' - ' + trans('modules.GoogleAnalytics.docs_events_7')
        },
        send(data = {}) {
            GoogleAnalyticsEvents.sendEvent(this.key, data)
        },
    },

    OnlineCoursePurchase: {
        key: 'online-course-purchase',
        get description() {
            return this.key + ' - ' + trans('modules.GoogleAnalytics.docs_events_8')
        },
        send(data = {}) {
            GoogleAnalyticsEvents.sendEvent(this.key, data)
        },
    },

    sendEvent(eventKey, data = {}) {
        if (typeof window.analytics !== 'function') {
            if(window.dataLayer) {
                window.dataLayer.push({
                    event: eventKey,
                    data,
                });
            } else {
                console.warn('No Google Analytics system enabled')
                return
            }
        } else {
            window.analytics('event', eventKey, data)
        }

        console.log(`Google Analytics Event:${eventKey} was fired`)
    },
}

export default GoogleAnalyticsEvents
